export default "__VITE_ASSET__CjEF9dmR__"